import { useSnackbar } from 'notistack';

export const UseAlert = () => {
    const { enqueueSnackbar } = useSnackbar();

    const NewNotification = (message: string, type: 'success' | 'error' | 'warning' | 'info') => {        
        enqueueSnackbar(message, { variant:type, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }});
    }
    return { NewNotification}
}   